import { Box, Button, TextField } from '@mui/material';
import TextFieldComponent from 'components/TextFieldComponent';
import React, { ChangeEvent, useState } from 'react';
import imagem1 from '../../../../../src/assets/images/proposalImagens/childrenImage.jpeg';
import imagem2 from '../../../../../src/assets/images/proposalImagens/recognitialImage.jpeg';

interface FormsProposalProps {
  formData: { image1?: File | null; image2?: File | null };
  onChange: (data: { image1?: File | null; image2?: File | null }) => void;
  goToNextPage: () => void;
}

const FormsProposalSecond: React.FC<FormsProposalProps> = ({
  formData,
  onChange,
  goToNextPage,
}) => {
  const [previewImage1, setPreviewImage1] = useState<string | null>(imagem1);
  const [previewImage2, setPreviewImage2] = useState<string | null>(imagem2);

  function handleChange(event: ChangeEvent<HTMLInputElement>): void {
    const { name, files } = event.target;
    if (name === 'image1' || name === 'image2') {
      const file = files && files[0] ? files[0] : null;
      onChange({
        ...formData,
        [name]: file,
      });
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          if (name === 'image1') {
            setPreviewImage1(reader.result as string);
          } else if (name === 'image2') {
            setPreviewImage2(reader.result as string);
          }
        };
        reader.readAsDataURL(file);
      }
    }
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: '#202940',
        width: '98%',
        height: '80%',
        boxShadow: '0 4px 24px rgba(24, 19, 19, 0.25)',
        padding: 3,
        gap: 2,
        '@media (max-width: 600px)': {
          padding: 2,
          width: '100%',
        },
      }}
    >
      <Box
        component="h2"
        sx={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#fff', mb: 2 }}
      >
        Preencher dados pagina 2
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          gap: 2,
          mb: 2,
          '@media (max-width: 600px)': {
            flexDirection: 'column',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '48%',
            '@media (max-width: 600px)': {
              width: '100%',
            },
          }}
        >
          <Box
            component="img"
            src={previewImage1 || undefined}
            alt="Preview Image 1"
            sx={{ width: '100%', height: 'auto', borderRadius: 1, mb: 2 }}
          />
          <TextField
            variant="outlined"
            label="Image 1"
            fullWidth
            type="file"
            name="image1"
            onChange={handleChange}
            sx={{ borderRadius: 1 }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '48%',
            '@media (max-width: 600px)': {
              width: '100%',
            },
          }}
        >
          <Box
            component="img"
            src={previewImage2 || 'placeholder2.jpg'}
            alt="Preview Image 2"
            sx={{ width: '100%', height: 'auto', borderRadius: 1, mb: 2 }}
          />
          <TextField
            variant="outlined"
            fullWidth
            label="Image 2"
            type="file"
            name="image2"
            onChange={handleChange}
            sx={{ borderRadius: 1 }}
          />
        </Box>
      </Box>
      <Button
        onClick={goToNextPage}
        sx={{
          backgroundColor: '#1976d2',
          color: 'white',
          '&:hover': {
            backgroundColor: '#115293',
          },
        }}
        variant="contained"
      >
        Salvar
      </Button>
    </Box>
  );
};

export default FormsProposalSecond;
